import React from "react";

const AngkutanNataru = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Nataru 2023"
        src="https://lookerstudio.google.com/embed/reporting/5f63e24f-5e44-4c9e-aab7-c11aac8b0624/page/p_4gu0eeslvc"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
      <iframe
        title="Data Nataru 2024"
        src="https://lookerstudio.google.com/embed/reporting/caeb3756-653b-444a-8d74-7e5b813df4da/page/daSTD"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
      <iframe
        title="Data Nataru 2025"
        src="https://lookerstudio.google.com/embed/reporting/fa11c4ef-df44-4c65-9e5f-e29603fa358b/page/XYjqC"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default AngkutanNataru;
